import { render, staticRenderFns } from "./AssignLearningtoself.vue?vue&type=template&id=ee5d5786&scoped=true"
import script from "./AssignLearningtoself.vue?vue&type=script&lang=js"
export * from "./AssignLearningtoself.vue?vue&type=script&lang=js"
import style0 from "./AssignLearningtoself.vue?vue&type=style&index=0&id=ee5d5786&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee5d5786",
  null
  
)

export default component.exports